import React, { FC, memo } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, Button, Divider } from "@mui/material";
import {
    useMultipleLocalizedText,
} from '../contexts/Localization/localizationHooks';
import OfferLetterPreview from "./OfferLetterPreview";

interface DocumentViewerProps {
    open: boolean
    documentURL: any
    type: string

    onClose?: () => void
    onSign?: () => void
}

const DocumentViewer: FC<DocumentViewerProps> = ({
    open,
    documentURL,
    type,
    onClose,
    onSign
}) => {
    const {
        SIGN,
        CLOSE,
        CANCEL
    } = useMultipleLocalizedText();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            fullScreen
            sx={{ marginTop: '50px' }}
        >
            <OfferLetterPreview 
                documentURL={documentURL}
                type={type}
            />

            <Divider />
            <DialogActions sx={{ position: 'sticky', bottom: 0, backgroundColor: 'white' }}>
                {
                    type == 'UNSIGNED' ?
                        <Button onClick={onClose}>{CANCEL}</Button>
                        : <Button onClick={onClose}>{CLOSE}</Button>
                }
                {
                    type == 'UNSIGNED' ?
                        <Button color="primary" variant="contained" onClick={onSign}>{SIGN}</Button>
                        : null
                }
            </DialogActions>
        </Dialog>
    );
};

DocumentViewer.propTypes = {
    open: PropTypes.bool.isRequired,
    documentURL: PropTypes.any,
    type: PropTypes.string,
    onClose: PropTypes.func.isRequired
};

export default memo(DocumentViewer);